import axios from "axios";
import { ApiKey, liveURL } from "../constants/Consts";

const MAIN_URL = `${liveURL}/classform`;

export async function getFields() {
  return axios.get(`${MAIN_URL}/fields`, {
    headers: { apikey: ApiKey },
  }).then(res => res.data);
}

export async function saveFields(fields) {
  return axios.post(`${MAIN_URL}/fields`, fields, {
    headers: { apikey: ApiKey },
  }).then(res => res.data);
}

export async function getData() {
  return axios.get(`${MAIN_URL}/data`, {
    headers: { apikey: ApiKey },
  }).then(res => res.data);
} 